<div class="card">
  <form [formGroup]="smtpConfigurationForm" (ngSubmit)="onSubmit(smtpConfigurationForm)">
    <div class="card-header font-weight-bold">
      <div class="row justify-content-between align-items-center">
        <div class="form_head col-12 col-sm-12 col-md-7 col-lg-11 col-xl-11">
          <h2>
            <span>SMTP Configuration</span>
          </h2>
        </div>
        <div class="col-12 col-sm-12 col-md-5 col-lg-1 col-xl-1">
          <div class="text-left text-md-right">
            <button
              [disabled]="userPermissions.smtp_setting.view && !userPermissions.smtp_setting.edit"
              type="submit"
              class="btn btn-primary btn-block">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <fieldset [disabled]="userPermissions.smtp_setting.view && !userPermissions.smtp_setting.edit">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>From Address *</label>
                  <input type="text" class="form-control" formControlName="from_address" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>From Name *</label>
                  <input type="text" class="form-control" formControlName="from_name" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>SMTP Server *</label>
                  <input type="text" class="form-control" formControlName="smtp_server" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>SMTP Port *</label>
                  <input type="text" class="form-control" formControlName="smtp_port" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Email *</label>
                  <input type="text" class="form-control" formControlName="smtp_username" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Password</label>
                  <input type="password" class="form-control" formControlName="smtp_password" />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </form>
</div>
